import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="column-wide, colums"><path d="M2.75 19.25H2V20H2.75V19.25ZM2.75 4.75V4H2V4.75H2.75ZM21.25 4.75H22V4H21.25V4.75ZM21.25 19.25V20H22V19.25H21.25ZM3.5 19.25V4.75H2V19.25H3.5ZM20.5 4.75V19.25H22V4.75H20.5ZM21.25 18.5H2.75V20H21.25V18.5ZM2.75 5.5H21.25V4H2.75V5.5Z" fill="currentColor"/><path d="M11.25 19.25V20H12.75V19.25H11.25ZM12.75 4.75V4H11.25V4.75H12.75ZM12.75 19.25V4.75H11.25V19.25H12.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconColumnWide;
